import React, { useEffect, useState, useRef } from "react";
import axiosInstance from '../axiosInstance';
import { useParams, useNavigate, } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaPen, FaPlus, FaTrash } from 'react-icons/fa';
import { FiArrowLeft } from "react-icons/fi";
import { API_URL_All } from "../api";
import * as general from '../libs/general';
import AdLayout from '../components/AdLayout';
import FeeEditor from '../components/orders/FeeEditor';
import Fee4Editor from '../components/orders/Fee4Editor';
import UserLevelEditor from '../components/orders/UserLevelEditor';
import PriceTypeEditor from '../components/orders/PriceTypeEditor';
import { fetchPriceLevelPermissions } from "../libs/customerCreatePermission";
import { customerDetailPath } from "../routes/customerRoutes";

const Level = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [model, setModel] = useState({});
  const [customerCodes, setCustomerCodes] = useState("");
  const [feeEditorData, setfeeEditorData] = useState(null);
  const [fee4EditorData, setfee4EditorData] = useState(null);
  const [userLevelEditorData, setUserLevelEditorData] = useState(null);
  const [priceTypeData, setPriceTypeData] = useState(null);
  const [levelFeaturePerm, setLevelFeaturePerm] = useState({
    loaded: false,
    canView: false,
    canCreate: false,
    canEdit: false,
    canDelete: false,
  });
  const isCreateMode = !id || String(id) === "0";
  const canWriteLevel = levelFeaturePerm.loaded && (isCreateMode ? levelFeaturePerm.canCreate : levelFeaturePerm.canEdit);
  const canReadLevel = levelFeaturePerm.loaded && (isCreateMode ? levelFeaturePerm.canCreate : (levelFeaturePerm.canView || levelFeaturePerm.canEdit));

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await axiosInstance.get(`/api/users/all`);
        const list = response.data.map(item => item.customerCode).filter(code => code);
        const uniqueList = [...new Set(list)];
        var joinedCodes = uniqueList.join(',');
        setCustomerCodes(joinedCodes);
      } catch (error) {
        console.error(error);
      }
    };

    fetchCustomers();
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const p = await fetchPriceLevelPermissions(axiosInstance);
      if (cancelled) return;
      setLevelFeaturePerm({
        loaded: true,
        canView: Boolean(p?.canView),
        canCreate: Boolean(p?.canCreate),
        canEdit: Boolean(p?.canEdit),
        canDelete: Boolean(p?.canDelete),
      });
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!canReadLevel) return;
    fetchOneRecord(id);
  }, [id, canReadLevel]);
  const fetchOneRecord = async (id) => {
    try {
      if (!id) id = 0;
      var requestApi = `/api/levels/getLevel?id=${id}`;
      const response = await axiosInstance.get(requestApi);

      setModel({ ...response.data.data});
      console.log(response.data.data);

    } catch (error) {
      console.error(error);
      toast.error(error.message);
    }
  };

  const openFeeEditor = (params) => {
    if (!canWriteLevel) return;
    setfeeEditorData(params);
  };
  const openFee4Editor = (params) => {
    if (!canWriteLevel) return;
    setfee4EditorData(params);
  };
  const openUserFeeEditor = (params) => {
    if (!canWriteLevel) return;
    setUserLevelEditorData(params);
  };
  const openPriceTypeEditor = (params) => {
    if (!canWriteLevel) return;
    setPriceTypeData(params);
  };

  const refreshPage = async (filter) => {
    fetchOneRecord(model.id);
  };

  const getLinePriceTypes = (lineId) => {
    return (model.priceTypes ?? []).filter((item) => item.lineId === lineId);
  };

  const getDefaultPriceTypeId = (lineId) => {
    const defaultPriceType = getLinePriceTypes(lineId).find((item) => item.isDefault);
    return defaultPriceType?.id ?? null;
  };

  const isLineDefaultPriceType = (lineId, priceTypeId = null) => {
    return getDefaultPriceTypeId(lineId) === priceTypeId;
  };

  const handlePriceTypeChange = (levelId, lineId, priceTypeId) => {
    if (!canWriteLevel) return;
    const payload = { id: priceTypeId, levelId, lineId };
    axiosInstance.post('/api/levels/setDefaultPriceType', payload)
      .then((response) => {
        if (response.data.success === false) {
          toast.error(response.data.message);
          return;
        }
        toast.success(response.data.message);
        fetchOneRecord(levelId);
      })
      .catch((error) => {
        toast.error(error.message);
      });
  };

  const handleDeleteFee = (feeId) => {
    if (!levelFeaturePerm.canDelete) {
      toast.warning("Bạn không có quyền xóa.");
      return;
    }
    general.openConfirm(async () => {
      try {
        const response = await axiosInstance.post(`/api/levels/deleteFee/${feeId}`, {});
        if (!response.data.success) {
          toast.error(response.data.message);
          return;
        }
        toast.success(response.data.message);
        fetchOneRecord(model.id);
      } catch (error) {
        console.error(error);
        toast.error(error.response?.data?.message || error.response?.data || error.message);
      }
    }, "Bạn có chắc chắn muốn xóa khung giá này không?");
  };

  const getFeesByPriceType = (fees, priceTypeId = null) => {
    return (fees ?? []).filter((item) => (priceTypeId ? item.priceTypeId === priceTypeId : !item.priceTypeId));
  };

  const renderFeeActions = ({ itemId, no, vat = false }) => (
    <div className="d-flex align-items-center justify-content-center">
      {canWriteLevel && (
        <button className="px-1 py-0 btn" onClick={() => vat ? openFee4Editor({ levelId: model.id, id: itemId, no }) : openFeeEditor({ levelId: model.id, id: itemId, no })}>
          <FaPen className="text-primary" size={12} />
        </button>
      )}
      {levelFeaturePerm.canDelete && (
        <button className="px-1 py-0 btn" onClick={() => handleDeleteFee(itemId)}>
          <FaTrash className="text-danger" size={12} />
        </button>
      )}
    </div>
  );

  const renderFeeTable = ({ lineId, type, fees, vat = false, priceTypeId = null, radioName }) => {
    const filteredFees = getFeesByPriceType(fees, priceTypeId);
    const openEditor = vat ? openFee4Editor : openFeeEditor;
    const addParams = {
      levelId: model.id,
      lineId,
      type,
      no: filteredFees.length + 1,
    };
    if (priceTypeId) addParams.priceTypeId = priceTypeId;

    return (
      <table className="table table-striped table-hover table-bordered">
        <thead className="table-primary">
          <tr>
            <th width="50px">STT</th>
            <th><span data-note={type}>Khoảng</span></th>
            <th><span data-note="vnđ">Giá</span></th>
            {vat && <th><span data-note="vnđ">Phí đầu mục</span></th>}
            {vat && <th><span data-note="%">Phí ủy thác</span></th>}
            <th width="50px">
              {canWriteLevel && <a onClick={() => openEditor(addParams)}><FaPlus /></a>}
            </th>
          </tr>
        </thead>
        <tbody>
          {filteredFees.map((item, index) => (
            <tr key={item.id}>
              <td>{index + 1}</td>
              <td>{item.start}-{item.end}</td>
              <td>{item?.fee?.toLocaleString("vi-VN")}</td>
              {vat && <td>{item?.feeItem?.toLocaleString("vi-VN")}</td>}
              {vat && <td>{item?.feeEntrust?.toLocaleString("vi-VN")}</td>}
              <td>{renderFeeActions({ itemId: item.id, no: index + 1, vat })}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  const lineConfigs = [
    {
      lineId: 1,
      priceTypeGroup: 'ecommercePriceType',
      addLabel: 'TMĐT',
      weightTitle: 'Line thương mại điện tử: Hàng nặng',
      sizeTitle: 'Line thương mại điện tử: Hàng cồng kềnh',
      weightFees: model.ecommerceWeightFees,
      sizeFees: model.ecommerceSizeFees,
      vat: false,
    },
    {
      lineId: 4,
      priceTypeGroup: 'economyPriceType',
      addLabel: 'Line thường',
      weightTitle: 'Line thường: Hàng nặng',
      sizeTitle: 'Line thường: Hàng cồng kềnh',
      weightFees: model.economyWeightFees,
      sizeFees: model.economySizeFees,
      vat: false,
    },
    {
      lineId: 11,
      priceTypeGroup: 'handheldPriceType',
      addLabel: 'Line XT',
      weightTitle: 'Line XT: Hàng nặng',
      sizeTitle: 'Line XT: Hàng cồng kềnh',
      weightFees: model.handheldWeightFees,
      sizeFees: model.handheldSizeFees,
      vat: false,
    },
    {
      lineId: 12,
      priceTypeGroup: 'vatPriceType',
      addLabel: 'Line VAT',
      weightTitle: 'Line chính ngạch: Hàng nặng',
      sizeTitle: 'Line chính ngạch: Hàng cồng kềnh',
      weightFees: model.vatWeightFees,
      sizeFees: model.vatSizeFees,
      vat: true,
    },
  ];

  const handleSubmitForm = async (e) => {
    e.preventDefault();
    if (!canWriteLevel) {
      toast.warning("Bạn không có quyền cập nhật.");
      return;
    }
    var errorTag = e.currentTarget.querySelector('.error-msg');
    if (errorTag) return;

    try {
      var a = model;
      var requestApi = `/api/levels/saveLevel`;
      const response = await axiosInstance.post(requestApi, model);
      if (!response.data.success) {
        general.showFormError('.form_validate', response.data);
        console.log(response.data);
        return;
      }
      console.log(response);
      toast.success(response.data.message, { position: "top-right" });
      fetchOneRecord(response.data.data);

    } catch (error) {
      toast.error(error.message);
    }

  };


  return (
    <div>
      <AdLayout>
        <div className="web-font">
        {levelFeaturePerm.loaded && !canReadLevel ? (
          <div className="container-fluid p-3 p-md-4">
            <div className="alert alert-warning mb-0">Bạn không có quyền truy cập màn hình này.</div>
          </div>
        ) : (
        <>

        <div className="mt-2 container p-0">
          <div className="card shadow-lg1 mb-3">

            <div className="block-header mb-2 position-relative">
              {model.id && (<span className="record_id">ID: {model.id}</span>)}
              <div className="department-page-header">
                <button
                  type="button"
                  className="department-page-header__back"
                  onClick={() => navigate(-1)}
                  aria-label="Quay lại"
                  title="Quay lại"
                >
                  <FiArrowLeft size={18} />
                </button>
                <div>{model.id ? 'Thông tin bảng giá' : 'Bảng giá mới'}</div>
              </div>
            </div>
            <form id="form_level" className="form_validate" autoComplete="off" onSubmit={handleSubmitForm}>

              <div className="container form-editor">
                <h5></h5>
                <div className="row">
                  <div className="col-md-6 form-item">
                    <div className="row">
                      <label className="form-label col-form-label col-sm-4 col-4 "><span className="required">Tên bảng giá</span></label>
                      <div className="col-sm-8 col-8"><input name="name" placeholder="Tên level" type="text" className="form-control" data-required="Phải nhập mục này" value={model.name} readOnly={!canWriteLevel} onChange={(e) => setModel({ ...model, name: e.target.value })} /></div>
                    </div>
                  </div>
                  <div className="col-md-6 form-item">
                    <div className="row">
                      <label className="form-label col-form-label col-sm-4  col-4">Mã</label>
                      <div className="col-sm-8  col-8"><input name="name" placeholder="Mã" type="text" className="form-control" value={model.code} readOnly={!canWriteLevel} onChange={(e) => setModel({ ...model, code: e.target.value })} /></div>
                    </div>
                  </div>
                </div>

                <div className="text-center">
                  <button type="button" variant="secondary" className="btn btn-sm btn-secondary m-2 d-none" onClick={() => navigate(general.popUrl())}>
                    Quay lại
                  </button>
                  {canWriteLevel && (
                    <button type="submit" className="btn btn-sm btn-success m-2">
                      Lưu
                    </button>
                  )}
                </div>
              </div>
            </form>
	            <div>
	              <section className="border-bottom p-2 reset-table">

	                <div className="container">
	                  {model.id && lineConfigs.map((config) => (
	                    <div key={config.lineId}>
	                      <div className="row">
	                        <div className="col-md-6">
	                          <div className="card mb-2">
	                            <div className="row">
	                              <div className="col-12">
	                                <div className="p-3">
	                                  <p className="fw-bold">{config.weightTitle}</p>
	                                  <div className="subtitle bg-01 d-flex justify-content-between align-items-center">
	                                    <span>Bảng giá phổ thông</span>
	                                    <input type="radio" name={config.priceTypeGroup} checked={isLineDefaultPriceType(config.lineId, null)} disabled={!canWriteLevel} onChange={() => handlePriceTypeChange(model.id, config.lineId, null)} />
	                                  </div>
	                                  {renderFeeTable({ lineId: config.lineId, type: 'kg', fees: config.weightFees, vat: config.vat })}
	                                  <div className="sub-price">
	                                    {getLinePriceTypes(config.lineId).map((priceType, index) => (
	                                      <div key={priceType.id}>
	                                        <div className="subtitle d-flex justify-content-between align-items-center">
	                                          <span>{priceType.name}</span>
	                                          <div className="d-flex align-items-center">
                                            {canWriteLevel && (
                                              <button className="px-1 py-0 btn" onClick={() => openPriceTypeEditor({ levelId: model.id, id: priceType.id, no: index + 1 })}>
                                                <FaPen className="text-primary" size={10} />
                                              </button>
                                            )}
	                                            <input type="radio" name={config.priceTypeGroup} checked={isLineDefaultPriceType(config.lineId, priceType.id)} disabled={!canWriteLevel} onChange={() => handlePriceTypeChange(model.id, config.lineId, priceType.id)} />
	                                          </div>
	                                        </div>
	                                        {renderFeeTable({ lineId: config.lineId, type: 'kg', fees: config.weightFees, vat: config.vat, priceTypeId: priceType.id })}
	                                      </div>
	                                    ))}
	                                  </div>
	                                </div>
	                              </div>
	                            </div>
	                          </div>
	                        </div>

	                        <div className="col-md-6">
	                          <div className="card mb-2">
	                            <div className="row">
	                              <div className="col-12">
	                                <div className="p-3">
	                                  <p className="fw-bold">{config.sizeTitle}</p>
	                                  <div className="subtitle bg-01">Bảng giá phổ thông</div>
	                                  {renderFeeTable({ lineId: config.lineId, type: 'm3', fees: config.sizeFees, vat: config.vat })}
	                                  <div className="sub-price">
	                                    {getLinePriceTypes(config.lineId).map((priceType, index) => (
	                                      <div key={priceType.id}>
	                                        <div className="subtitle d-flex justify-content-between align-items-center">
	                                          <span>{priceType.name}</span>
                                          {canWriteLevel && (
                                            <button className="px-1 py-0 btn" onClick={() => openPriceTypeEditor({ levelId: model.id, id: priceType.id, no: index + 1 })}>
                                              <FaPen className="text-primary" size={10} />
                                            </button>
                                          )}
	                                        </div>
	                                        {renderFeeTable({ lineId: config.lineId, type: 'm3', fees: config.sizeFees, vat: config.vat, priceTypeId: priceType.id })}
	                                      </div>
	                                    ))}
	                                  </div>
	                                </div>
	                              </div>
	                            </div>
	                          </div>
	                        </div>
	                      </div>
	                      <div className="row">
	                        {canWriteLevel && (
	                        <div className="col-12 mb-2">
	                          <button type="button" className="small-btn" onClick={() => openPriceTypeEditor({ levelId: model.id, lineId: config.lineId, no: getLinePriceTypes(config.lineId).length + 1 })}>
	                            Thêm bảng giá: {config.addLabel}
	                          </button>
	                        </div>
	                        )}
	                      </div>
	                    </div>
	                  ))}
	                </div>

                <div className="container mt-5">
                  {model.id && (
                    <div className="" data-group-text="Danh sách khách thuộc bảng giá này">
                      <div className="table-responsive">
                        <table className="table-01">
                          <thead className="table-primary">
                            <tr>
                              <th width="50px"></th>
                              <th>Mã KH</th>
                              <th>Tên</th>
                              <th>Email</th>
                              <th>Ngày đăng ký</th>
                              <th width="50px">
                                {canWriteLevel && <a onClick={() => openUserFeeEditor({ levelId: model.id, no: model.users.length + 1 })}><FaPlus /></a>}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {model.users && model.users.map((item, index) => (
                              <tr key={item.id}>
                                <td title={item.id}>{index + 1}</td>
                                <td className="text-start link-normal"><span onClick={() => navigate(customerDetailPath(item.id))}>{item.customerCode}</span></td>
                                <td className="text-start">{item.name}</td>
                                <td className="text-start">{item.email}</td>
                                <td>{general.formatDate(item.createdDate)}</td>
                                <td>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>


              </section>
            </div>
            <div>

            </div>

          </div>
        </div>
        <input type="hidden" id="list_lines" value="TMĐT,Line Thường,Line XT,Line VAT" />
        <input type="hidden" id="list_customers" value={customerCodes} />

        {feeEditorData && (
          <FeeEditor data={feeEditorData} handleSearch={refreshPage} />
        )}
        {fee4EditorData && (
          <Fee4Editor data={fee4EditorData} handleSearch={refreshPage} />
        )}
        {userLevelEditorData && (
          <UserLevelEditor data={userLevelEditorData} handleSearch={refreshPage} />
        )}
        {priceTypeData && (
          <PriceTypeEditor data={priceTypeData} handleSearch={refreshPage} />
        )}
        </>
        )}
        </div>
      </AdLayout>
    </div>
  );
};

export default Level;
